import {productColorConfigurationFromFormData} from '@/modules/commerce/product-color/configuration';
import type {CommerceProductColor} from '@/sanity/schemas/types';

export function cabFloorMatEdgingColorConfigurationFromFormData(
	edgingColors: CommerceProductColor[],
	name: string,
	formData: FormData,
) {
	let config: string | undefined;
	const edgingColorEnabled = formData.get(name) === 'enabled';

	if (edgingColorEnabled) {
		// Fall back to the first available edging color if the user hasn't selected one yet:
		const initialEdgingColor = edgingColors.at(0);
		config = initialEdgingColor?._id;

		// Fetch the user's selected edging color:
		const edgingColorConfig = productColorConfigurationFromFormData(
			edgingColors,
			`${name}.colorId`,
			formData,
		);
		if (edgingColorConfig) {
			config = edgingColorConfig;
		}
	}

	return config;
}
